import { App, URLOpenListenerEvent } from "@capacitor/app";
import { onBeforeMount, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";

export default function () {
  const router = useRouter();

  onBeforeMount(() => {
    App.addListener("appUrlOpen", (e: URLOpenListenerEvent) => {
      const {
        pathname,
        search,
        hash,
      } = new URL(e.url);

      router.replace(`${pathname}${search}${hash}`);
    });
  });

  onBeforeUnmount(() => {
    App.removeAllListeners();
  });
}
